<app-gallery [galleryId]="'1'" [section]="projUid + 'about-project'" [autoPlay]="false" [showThumbs]="false"
class="about-project"></app-gallery>
